import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { useDynamicComponents } from "../../hooks/useDynamicComponents";
import { NoteAdd } from "@mui/icons-material";

const AddPageDialog = ({ buttonText, onSubmit }) => {
  const [open, setOpen] = useState(false);
  const [component, setComponent] = useState("");

  const { DYNAMIC_COMPONENTS } = useDynamicComponents();

  const handleClickOpen = () => {
    setComponent("");
    setOpen(true);
  };

  const handleSubmit = () => {
    setOpen(false);
    if (component !== "") {
      onSubmit(component);
    }
  };

  const handleAbort = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClickOpen}
        startIcon={<NoteAdd />}
      >
        {buttonText}
      </Button>
      <Dialog
        open={open}
        onClose={handleAbort}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Seite hinzufügen</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Wähle die Art der Seite, die hinzugefügt werden soll aus:
          </DialogContentText>
          <FormControl fullWidth sx={{ marginTop: "0.5em" }}>
            <InputLabel id="new-page-select-label">Seite</InputLabel>
            <Select
              labelId="new-page-select-label"
              id="new-page-select-input"
              value={component}
              label="Seite"
              onChange={(event) => setComponent(event.target.value)}
            >
              <MenuItem disabled value="">
                <em>Seite auswählen</em>
              </MenuItem>
              {Object.entries(DYNAMIC_COMPONENTS).map(([key, value], index) => {
                if (value.unselectable) {
                  return;
                }
                return (
                  <MenuItem key={`new-page-component-${index}`} value={key}>
                    {value.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAbort}>Abbrechen</Button>
          <Button onClick={handleSubmit} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddPageDialog;
